import { Input, Textarea } from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"
import { IKReactSelect } from "../../../../ui-kit"
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { CmFieldTypeEnum } from "../../../constants"
import DateCustomInput from "../../DateCustomInput"

const DefaultValueFormComponent = ({
  field,
  form,
  type,
}): React.ReactElement => {
  const { t } = useTranslation()

  if (CmFieldTypeEnum.Text === type) {
    return <Input {...field} onChange={(e) => {
      form.setFieldValue(
        "schema.defaultValue",
        (
          e.target.value !== "" ?
            e.target.value :
            undefined
        )
      )
    }} />
  }

  if (type === CmFieldTypeEnum.Textarea) {
    return <Textarea {...field}
      onChange={(e) => {
        form.setFieldValue(
          "schema.defaultValue",
          (
            e.target.value !== "" ?
              e.target.value :
              undefined
          )
        )
      }} />
  }

  if (type === CmFieldTypeEnum.Boolean) {
    return (
      <IKReactSelect
        variant="compact"
        captureMenuScroll={false}
        menuPlacement="auto"
        isClearable
        value={{
          label: typeof field.value !== "undefined" ? String(field.value) : undefined,
          value: field.value,
        }}
        options={[true, false].map(val => ({
          label: String(val),
          value: val,
        }))}
        onChange={newVal => form.handleChange({ target: { name: "schema.defaultValue", value: newVal?.value } })}
      />
    )
  }

  if (type === CmFieldTypeEnum.Number) {
    return (
      <Input
        {...field}
        type="number"
        onChange={(e) => {
          form.setFieldValue(
            "schema.defaultValue",
            (
              e.target.value !== "" ?
              Number(e.target.value) :
              undefined
            )
          )
        }}
      />
    )
  }

  if (type === CmFieldTypeEnum.Date) {
    return (
      <DatePicker
        selected={field.value ? new Date(field.value) : undefined}
        isClearable
        customInput={React.createElement(React.forwardRef(DateCustomInput))}
        onChange={(newDate: Date | null) => {
          form.handleChange({
            target: {
              name: "schema.defaultValue",
              value: newDate?.toISOString()
            }
          })
        }}
      />
    )
  }

  if (type === CmFieldTypeEnum.SingleSelect) {
    return (
      <IKReactSelect
        placeholder={t("set_a_default_value", "Set a default value")}
        variant="compact"
        captureMenuScroll={false}
        menuPlacement="auto"
        isClearable
        value={{
          label: typeof field.value !== "undefined" ? String(field.value) : undefined,
          value: field.value,
        }}
        options={form.values?.schema?.selectOptions?.map(option => ({
          label: String(option),
          value: option
        }))}
        onChange={newVal => form.handleChange({
          target: {
            name: "schema.defaultValue",
            value: newVal?.value
          }
        })}
      />
    )
  }

  if (type === CmFieldTypeEnum.MultiSelect) {
    return (
      <IKReactSelect
        placeholder={t("set_a_default_value", "Set a default value")}
        variant="compact"
        captureMenuScroll={false}
        menuPlacement="auto"
        isClearable
        isMulti
        value={
          field?.value?.map(val => ({
            label: String(val),
            value: val,
          })) ?? []
        }
        options={
          form.values?.schema?.selectOptions?.map(option => ({
            label: String(option),
            value: option
          }))
        }
        onChange={newVals => form.handleChange({
          target: {
            name: "schema.defaultValue",
            value: newVals.length > 0 ? newVals?.map(newVal => newVal.value) : undefined
          }
        })}
      />
    )
  }

  return <></>
}

export default DefaultValueFormComponent
